import { useEffect } from "react";
import { App } from "antd";
import type { MessageInstance } from "antd/es/message/interface";
import type { NotificationInstance } from "antd/es/notification/interface";

// Bridge for code outside React components (shared utils such as
// handleSubmitFormResponseManage or showDeleteUndoNotification) that must
// still raise toasts. antd v5's static message/notification do not render
// under React 19, so this exposes the context-bound instances of App.useApp()
// instead — antd's documented pattern for non-component code.
let messageApi: MessageInstance | null = null;
let notificationApi: NotificationInstance | null = null;

/** Renders nothing. Mount it once inside antd's `<App>`. */
export const AntdAppApiBridge = () => {
  const { message, notification } = App.useApp();

  useEffect(() => {
    messageApi = message;
    notificationApi = notification;
    return () => {
      messageApi = null;
      notificationApi = null;
    };
  }, [message, notification]);

  return null;
};

const notMounted = (api: string) =>
  new Error(
    `antd ${api} API is not available: render <AntdAppApiBridge /> inside antd's <App> before raising toasts from non-component code.`
  );

export const getMessageApi = (): MessageInstance => {
  if (!messageApi) throw notMounted("message");
  return messageApi;
};

export const getNotificationApi = (): NotificationInstance => {
  if (!notificationApi) throw notMounted("notification");
  return notificationApi;
};
